import React from 'react'
import ResetPassword from './ResetPassword'

class SetPassword extends React.Component {
  render(){
    return <ResetPassword setPassword={true} {...this.props}/>
  }
}

export default SetPassword



// WEBPACK FOOTER //
// ./src/js/components/SetPassword.js